import { useSendCommand } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { AddNewStatus } from '../../../api/commands';
import { StorymapState, SubtaskStatusCategory } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SaveNewStatus extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SaveNewStatus';

    public _key: number;

    public constructor(public name: string, public color: string, public category: SubtaskStatusCategory) {
        super(SaveNewStatus.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SaveNewStatus): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new AddNewStatus(state.id, action.name, action.color, action.category, 0),
        onSuccess: res => {
            action._key = res.Key
        }
    });
};

const reducer = (state: StorymapState, action: SaveNewStatus): void => {
    const status = state.subtaskStatuses.find(x => x.category == action.category && x.key == null);
    status.name = action.name;
    status.color = action.color;
    status.key = action._key;
};

//@ts-ignore
registerMiddleware(SaveNewStatus.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SaveNewStatus.ACTION_TYPE, reducer);
